import { useSelector } from 'react-redux';

import membersStrings from 'modules/members/strings';
import UpdatePointsButton from 'modules/members/components/UpdatePointsButton';
import SectionDivider from 'modules/common/components/SectionDivider';
import Loader from 'modules/common/components/Loader';
import { status } from 'constants/general';

import {
  ProfileInfoContainer,
  MemberName,
  Points,
  PointsIcon,
  PointsActionsButtonsWrapper,
  BlockedUserTag,
  BlockIcon,
  LoaderWrapper,
} from './MemberProfileInfo.style';

const { points, blockedUser } = membersStrings.memberProfile;

const MemberProfileInfoBanner = () => {
  const { member } = useSelector(state => state.members);
  const { details, updatingPointsStatus } = member;
  const { userEmail, awardedPoints, isBlocked } = details.data;
  return (
    <ProfileInfoContainer>
      <MemberName>{userEmail}</MemberName>
      <SectionDivider gap={14} />
      <Points isBlocked={isBlocked}>
        {updatingPointsStatus === status.FETCHING ? (
          <LoaderWrapper>
            <Loader width={10} height={10} thickness={5} />
          </LoaderWrapper>
        ) : (
          <PointsIcon isBlocked={isBlocked} />
        )}
        {awardedPoints} {points}
      </Points>
      <SectionDivider gap={14} />
      <PointsActionsButtonsWrapper>
        {isBlocked ? (
          <BlockedUserTag>
            <BlockIcon /> {blockedUser}
          </BlockedUserTag>
        ) : (
          <>
            <UpdatePointsButton toAddPoints />
            <UpdatePointsButton toAddPoints={false} />
          </>
        )}
      </PointsActionsButtonsWrapper>
    </ProfileInfoContainer>
  );
};

export default MemberProfileInfoBanner;
